<div class="card options-card">
  <div class="card-header bp-card-header">
    <i class="fas fa-envelope-open payment-options-icon"></i>
    <p class="font-weight-light bp-text">Billing</p>
  </div>
  <div class="card-body">

        <button class="btn btn-link btn-block clearfix accordion-btn" (click)="showPaperlessBilling=!showPaperlessBilling">
          <!--<i *ngIf="!showPaperlessBilling" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showPaperlessBilling" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Paperless Billing</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <p class="bp-text bp-small-text tall-p">
              Receive and review your bill online with our paperless billing service or
              <br />
              update your email address.
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 22%;" class="bp-link-red float-right">LEARN MORE<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
        </div>

        <button class="btn btn-link accordion-btn" (click)="showBudgetBilling=!showBudgetBilling">
          <!--<i *ngIf="!showBudgetBilling" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showBudgetBilling" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Budget Billing</div>
        </button>

        <div class="container accordion-container">
          <div class="row">
            <p class="bp-text bp-small-text tall-p">
              Our budget billing plan takes the guesswork out of paying your power bill
              <br />
              by averaging your monthly charges.
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 2%;" class="bp-link-red float-right"><i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
        </div>

        <button class="btn btn-link accordion-btn" (click)="showProjectShare=!showProjectShare">
          <!--<i *ngIf="!showProjectShare" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showProjectShare" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Project Share</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <p class="bp-text bp-small-text tall-p">
              Pledge to help others in your community.
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 22%;" class="bp-link-red float-right">LEARN MORE<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
        </div>
  
        <button class="btn btn-link accordion-btn" (click)="showFlatBill=!showFlatBill">
          <!--<i *ngIf="!showFlatBill" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showFlatBill" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Flat Bill</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <p class="bp-text bp-small-text tall-p">
              If the weather changes drastically, your monthly payments will not.
              <br />
              This plan offers a 12-month fixed contracted price that does not fluctuate
              <br />
              when your power usage does. It is based on your previous year's history
              <br />
              at your current location.
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 22%;" class="bp-link-red float-right">LEARN MORE<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
        </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/billing/billing.component.html